import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, LogOut } from 'lucide-react';

export const TryonLimitModal = ({ isOpen, onKeepExploring, onEndSession }) => {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/60 z-50 flex items-end sm:items-center justify-center"
      onClick={onKeepExploring}
    >
      <motion.div
        initial={{ y: '100%' }}
        animate={{ y: 0 }}
        exit={{ y: '100%' }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className="bg-white w-full sm:w-[400px] sm:rounded-2xl rounded-t-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-1 bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500" />
        <div className="p-6">
          <div className="w-16 h-16 bg-gradient-to-br from-amber-100 to-amber-50 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
            <Sparkles className="w-8 h-8 text-amber-500" />
          </div>
          <h3 className="text-xl font-bold text-slate-800 text-center mb-2">
            You've used all your try-ons!
          </h3>
          <p className="text-sm text-slate-500 text-center mb-2 leading-relaxed">
            Your last look is ready above.
          </p>
          <p className="text-sm text-slate-600 text-center mb-6 leading-relaxed">
            You can still generate{' '}
            <span className="font-semibold text-purple-600">Moments</span> or check your{' '}
            <span className="font-semibold text-blue-600">Size Guide</span> on your current look before wrapping up.
          </p>
          <div className="flex justify-center gap-6 mb-6">
            <div className="flex flex-col items-center gap-1.5">
              <div className="w-10 h-10 bg-purple-50 rounded-full flex items-center justify-center">
                <span className="text-lg">✨</span>
              </div>
              <span className="text-xs text-slate-500 font-medium">Moments</span>
            </div>
            <div className="flex flex-col items-center gap-1.5">
              <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                </svg>
              </div>
              <span className="text-xs text-slate-500 font-medium">Size Guide</span>
            </div>
          </div>
          <div className="space-y-2.5">
            <button
              onClick={onKeepExploring}
              className="w-full py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center justify-center gap-2 shadow-md shadow-blue-200"
              data-testid="keep-exploring-btn"
            >
              <Sparkles className="w-4 h-4" />
              Keep Exploring
            </button>
            <button
              onClick={onEndSession}
              className="w-full py-3 bg-slate-100 text-slate-600 rounded-xl font-medium hover:bg-slate-200 transition-colors flex items-center justify-center gap-2"
              data-testid="end-session-from-limit-btn"
            >
              <LogOut className="w-4 h-4" />
              View Session Summary
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};
